module.exports = __webpack_public_path__ + "static/media/scrum.d7b105a7.svg";